import { useEffect, useRef } from "react";
import { useToaster } from "./use-toaster";

export type SaveToasterProps = {
  title: string;
  inflight: boolean;
  success: boolean;
};

const TIMEOUT_MS_INFLIGHT = 10000;
const TIMEOUT_MS_COMPLETE = 3000;

export function useSaveToaster({ inflight, success, title }: SaveToasterProps) {
  const { toaster } = useToaster();
  const key = useRef<string>();

  useEffect(() => {
    if (!toaster) {
      return;
    }

    if (inflight) {
      if (key.current) {
        return;
      }

      key.current = toaster.show({
        message: `Saving ${title}...`,
        intent: "none",
        isCloseButtonShown: false,
        timeout: TIMEOUT_MS_INFLIGHT,
        icon: "floppy-disk",
        onDismiss: () => {
          key.current = undefined;
        },
      });
    } else if (key.current) {
      toaster.show(
        {
          message: success
            ? `Successfully saved ${title}`
            : `Failed saving ${title}`,
          intent: success ? "success" : "danger",
          icon: success ? "tick" : "remove",
          timeout: TIMEOUT_MS_COMPLETE,
        },
        key.current,
      );

      key.current = undefined;
    }
  }, [inflight, success, title, toaster]);

  useEffect(
    () => () => {
      if (key.current) {
        toaster?.dismiss(key.current);
      }
    },
    [toaster],
  );
}
